import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { superbillFlowsActions } from 'features/superbillFlows';

const useSuperbillFlows = () => {
  const dispatch = useDispatch();
  const getSuperbillFlow = useCallback(() => dispatch(superbillFlowsActions.getSuperbillFlow()), [dispatch]);
  const createSuperbillFlow = useCallback(superbill_flow => dispatch(superbillFlowsActions.createSuperbillFlow(superbill_flow)), [dispatch]);
  const updateSuperbillFlow = useCallback(superbill_flow => dispatch(superbillFlowsActions.updateSuperbillFlow(superbill_flow)), [dispatch]);
  const deleteSuperbillFlow = useCallback(() => dispatch(superbillFlowsActions.deleteSuperbillFlow()), [dispatch]);
  const clearLocalActiveSuperbillFlow = useCallback(() => dispatch(superbillFlowsActions.clearLocalActiveSuperbillFlow()), [dispatch]);

  return {
    getSuperbillFlow,
    createSuperbillFlow,
    updateSuperbillFlow,
    deleteSuperbillFlow,
    clearLocalActiveSuperbillFlow
  };
};

export default useSuperbillFlows;